import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.6_cac@6.7.14_db0@0.3.4_eslint@9.39.4_jiti@2.7.0__ioredi_9c558508c6cb69a629d5ac70baabd712/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.6_cac@6.7.14_db0@0.3.4_eslint@9.39.4_jiti@2.7.0__ioredi_9c558508c6cb69a629d5ac70baabd712/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}